import { ModuleManager, SectionList } from "@module-system";
import CommonConditions from "@lib/commonConditions";

import SnippetBtn from "./Components/SnippetBtn.vue";
import SnippetActiveBar from "./Components/SnippetActiveBar.vue";
import SnippetSnackbar from "./Components/SnippetSnackbar.vue";
import PhotoSnippetBridge from "./Components/PhotoSnippetBridge.vue";
import configurationProvider from "@/Core/configurationProvider";

import locales from "./locales";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "Snippet",
  version: "1.0.0",
  register() {
    const snippetSettings = configurationProvider.getObject("SNIPPET_SETTINGS", { isSnippetEnabled: true, isManualSnippetEnabled: true, isPhotoSnippetEnabled: false });

    ModuleManager.addLocales(locales, "Snippet");

    if (!snippetSettings.isSnippetEnabled) {
      return;
    }

    const hasManual = snippetSettings.isManualSnippetEnabled !== false;
    const hasPhoto = !!snippetSettings.isPhotoSnippetEnabled;

    // Nothing to register if both sub-features are off
    if (!hasManual && !hasPhoto) {
      return;
    }

    if (hasManual) {
      ModuleManager.addViewModule({
        key: "SnippetBtn",
        section: SectionList.CallButtonsList,
        ViewComponent: SnippetBtn,
        Condition: (rtcId) => {
          return CommonConditions.isAgent(rtcId);
        },
      });
    }

    // ActiveBar and Snackbar are shared by both manual and photo snippets
    ModuleManager.addViewModule({
      key: "SnippetActiveBar",
      section: SectionList.CallTopBar,
      ViewComponent: SnippetActiveBar,
    });

    ModuleManager.addViewModule({
      key: "SnippetSnackbar",
      section: SectionList.CallModal,
      ViewComponent: SnippetSnackbar,
    });

    if (hasPhoto) {
      ModuleManager.addViewModule({
        key: "PhotoSnippetBridge",
        section: SectionList.CallModal,
        ViewComponent: PhotoSnippetBridge,
        Condition: (rtcId) => {
          return CommonConditions.isAgent(rtcId);
        },
      });
    }
  },
};
export default module;
